import type { DrawerLayoutController } from "@stepapp/ui";
import React from "react";

export const drawerRef = React.createRef<DrawerLayoutController>();

export function openDrawer() {
  drawerRef.current?.open();
}

export function closeDrawer() {
  drawerRef.current?.close();
}
